import React from "react";
import { RichTextInput } from "components/ui";
import "./EmailContent.scss";

const EmailContent = ({
    message = "",
    handleChange,
    isResponse,
    preview,
    loading,
    hasCC,
    hasBCC,
}) => {
    const disableTextarea = preview || loading;

    // let heightReduceCount = 0;

    // heightReduceCount += hasBCC ? 1 : 0;
    // heightReduceCount += hasCC ? 1 : 0;

    // const newHeight =
    //     heightReduceCount === 0
    //         ? "170px"
    //         : heightReduceCount === 1
    //         ? "130px"
    //         : "90px";

    return (
        <div className='email__content mt-2'>
            <RichTextInput
                onChange={handleChange}
                value={message}
                placeholder={"message"}
                name='message'
                id='message-input'
                className={`react-quill`}
                inputClass='email__content__textarea'
                disabled={isResponse ? false : disableTextarea}
                hideLabel
            />            
        </div>
    );
};

export default EmailContent;
